module.exports = __webpack_public_path__ + "img/60x32x80-Kit.6ba1067b.png";